import Heading, { HeadingDefaults } from './Heading.svelte';
import Paragraph, { ParagraphDefaults } from './Paragraph.svelte';
import Footnote, { FootnoteDefaults } from './Footnote.svelte';
import Hero, { HeroDefaults } from './Hero.svelte';
import Timeline, { TimelineDefaults } from './Timeline.svelte';
import Image, { ImageDefaults } from './Image.svelte';
import Badge, { BadgeDefaults } from './Badge.svelte';
import ListItem, { ListItemDefaults } from './ListItem.svelte';
import NavBar, { NavBarDefaults } from './NavBar.svelte';
import PurchaseButton, { PurchaseButtonDefaults } from './PurchaseButton.svelte';
import FixedFooter, { FixedFooterDefaults } from './FixedFooter.svelte';
import RestoreButton, { RestoreButtonDefaults } from './RestoreButton.svelte';
import Embed, { EmbedDefaults } from './Embed.svelte';
import Video, { VideoDefaults } from './Video.svelte';
import deepmerge from 'deepmerge';


export let allComponents = ["navBar","heading", "paragraph", "footnote", "image","video", "hero", "badge", "listItem", "timeline", "purchaseButton", "restoreButton", "embed"]

export let componentsByName = {
	"video": [Video, VideoDefaults],
	"navBar": [NavBar, NavBarDefaults],
	"timeline": [Timeline, TimelineDefaults],
	"listItem": [ListItem, ListItemDefaults],
	"heading": [Heading, HeadingDefaults],
	"paragraph": [Paragraph, ParagraphDefaults],
	"footnote": [Footnote, FootnoteDefaults],
	"hero": [Hero, HeroDefaults],
	"badge": [Badge, BadgeDefaults],
	"image": [Image, ImageDefaults],
	"purchaseButton": [PurchaseButton, PurchaseButtonDefaults],
	"fixedFooter": [FixedFooter, FixedFooterDefaults],
	"restoreButton": [RestoreButton, RestoreButtonDefaults],
	"embed": [Embed, EmbedDefaults],
}



export let globalDefaultStyles = {
	"outer-container": {
		"name": "outer-container",
		"style": {
			"display": "flex",
			"flex-direction": "column",
			"align-items": "inherit",
			"justify-content": "inherit",
			"height": "auto",
			"width": "100%",

			"padding-top": "7px",
			"padding-bottom": "7px",
			"padding-left": "17px",
			"padding-right": "17px",

			"margin-top": "unset",
			"margin-bottom": "unset",
			"margin-left": "unset",
			"margin-right": "unset",

			"text-align": "left",
			"font-size": "inherit",
			"opacity": 1.0,
			"border-radius": "0px"
		}, 
	},
	"inner-container": {
		"name": "inner-container",
		"style": {
			"display": "flex",
			"flex-direction": "inherit",
			"align-items": "inherit",
			"justify-content": "inherit",
			"height": "auto",
			"border-radius": "15px"
		}, 
	},
	"meta": {
		"order": {
			"outer-container": -2,
			"inner-container": -1
		},
		"section": "body"
	}
}

export let pageDefaults = {
	"id": "$PAGE_ID",
	"type": "page",
	"args": {
	  "page-container": {
		"name": "page-container",
		"style": {
			"background-color": "#FFFFFFFF",
			"color": "#000000",
			"font": "",
			"padding-top": "44px",
			"padding-bottom": "26px",
			"flex-direction": "column",
			"align-items": "flex-start",
			"justify-content": "stretch"
		}
	  },
	  "footer": {
		"name": "footer",
		"style": {
			"background-color": "#00000080",
			"color": "#000000",
			"font": "",
			"flex-direction": "column",
			"align-items": "center",
			"justify-content": "stretch"
		}
	  },
	  "meta": {
		"order": {
			// "navbar": 0, // navbar is dead, replaced by standard navbar component
			"page-container": 1,
			"footer": 2,
		}
	  }
	}
}

export let navbarDefaults = {

}

export let footerDefaults = {

}


export const addDefaultStyle = (state) => {
	if (state.components.length > 0) {
		state.components.forEach((component) => {
			component.args = deepmerge.all([globalDefaultStyles, componentsByName[component.type][1], component.args])
		})
	}
}